/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.28/esri/copyright.txt for details.
*/
import { _ as e } from "../chunks/tslib.es6.js";
import { JSONSupport as t } from "../core/JSONSupport.js";
import { clone as r } from "../core/lang.js";
import { property as o } from "../core/accessorSupport/decorators/property.js";
import { cast as s } from "../core/accessorSupport/decorators/cast.js";
import { reader as n } from "../core/accessorSupport/decorators/reader.js";
import { subclass as p } from "../core/accessorSupport/decorators/subclass.js";
import { writer as i } from "../core/accessorSupport/decorators/writer.js";
import l from "./ExpressionInfo.js";
import m from "./elements/GroupElement.js";
import { ensureType as c, fromJSON as d, toJSON as a, buildTypeMaps as u } from "./support/elements.js";
var f;
const j = u(m);
let h = f = class extends t {
  constructor(e) {
    super(e), this.description = null, this.elements = null, this.expressionInfos = null, this.preserveFieldValuesWhenHidden = !1, this.title = null;
  }
  castElements(e) {
    return c(e, j);
  }
  readElements(e, t) {
    return d(t.formElements, j);
  }
  writeElements(e, t) {
    t.formElements = a(e, j);
  }
  clone() {
    return new f({
      description: this.description,
      expressionInfos: r(this.expressionInfos),
      elements: r(this.elements),
      title: this.title,
      preserveFieldValuesWhenHidden: this.preserveFieldValuesWhenHidden
    });
  }
};
e([o({
  type: String,
  json: {
    write: !0
  }
})], h.prototype, "description", void 0), e([o({
  json: {
    write: !0
  }
})], h.prototype, "elements", void 0), e([s("elements")], h.prototype, "castElements", null), e([n("elements", ["formElements"])], h.prototype, "readElements", null), e([i("elements")], h.prototype, "writeElements", null), e([o({
  type: [l],
  json: {
    write: !0
  }
})], h.prototype, "expressionInfos", void 0), e([o({
  type: Boolean,
  json: {
    default: !1,
    write: !0
  }
})], h.prototype, "preserveFieldValuesWhenHidden", void 0), e([o({
  type: String,
  json: {
    write: !0
  }
})], h.prototype, "title", void 0), h = f = e([p("esri.form.FormTemplate")], h);
const y = h;
export { y as default };